export const Saguaro = ({ className, strokeWidth, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    {/* trunk */}
    <rect x="10.25" y="2" width="3.5" height="20" rx="1.75" />
    {/* left arm */}
    <rect x="4.5" y="9" width="3.2" height="7.5" rx="1.6" />
    <rect x="4.5" y="12.3" width="7" height="3.2" rx="1.6" />
    {/* right arm */}
    <rect x="16.3" y="6.5" width="3.2" height="8.5" rx="1.6" />
    <rect x="12.5" y="10.8" width="7" height="3.2" rx="1.6" />
  </svg>
);
